// 📂 src/backend/firebase/schema/finance/balance-schema.ts

import z from 'zod';

export const BalanceSchema = z.object({
  workerId: z.string(),

  // Saldo neto normalizado: (+) a favor del trabajador, (-) deuda con el local
  balance_accounting: z.number().default(0),

  // Mapa Real: { "metodo_id": monto_en_moneda_nativa_del_metodo }
  // Esto sirve para saber exactamente cuántos "billetes" hay de cada cosa.
  method_balances: z.record(z.string(), z.number()).default({}),

  // --- ACUMULADORES INDIVIDUALES (Normalizados) ---
  period_earned_accounting: z.number().default(0),
  period_services_count: z.number().default(0),
  lifetime_earned_accounting: z.number().default(0),
  total_services_done: z.number().default(0),

  // Renta de Silla
  period_rent_debt_accounting: z.number().default(0),

  // --- ACUMULADORES DEL NEGOCIO (Solo para el doc "main") ---
  period_gross_accounting: z.number().default(0), // Total Bruto (Cortes)
  period_net_accounting: z.number().default(0), // Ganancia Neta (Cortes)
  period_commissions_accounting: z.number().default(0), // Lo que se llevan los barberos
  period_materials_accounting: z.number().default(0), // Costos de materiales
  period_expenses_accounting: z.number().default(0), // Gastos operativos (alquiler, luz, etc.)

  period_rent_income_accounting: z.number().default(0),
  last_rent_charged: z.any().nullable().default(null),

  lifetime_vault_received_accounting: z.number().optional(),

  last_settlement_at: z.any().nullable(),
  last_updated: z.any(),
});

// En src/backend/firebase/schema/finance/balance-schema.ts

// ... tu BalanceSchema

export type Balance = z.infer<typeof BalanceSchema>;
export type BalanceWithId = Balance & { id: string };
